export const BASE_URL = process.env.LOCAL_FACADE_SERVER_FULL_ADDRESS
//=============================================local store===============================================
export const EP_GET_BANK_DETAILS = '/get/bank/accounts'
export const EP_ADD_BANK_DETAILS = '/add/bank/account'
export const EP_Edit_BANK_DETAILS = '/update/bank/account'
export const EP_RUN_FIAT_WITHDRAWAL_REQUEST_OTP = '/withdrawal/request/otp'
export const EP_FIAT_WITHDRAWAL_REQUEST_RESEND_OTP = '/withdrawal/request/resend/otp'
export const EP_RUN_FIAT_WITHDRAWAL_REQUEST = '/withdrawal/request'
export const EP_RUN_DELETE_PAYMENT_METHOD = '/delete/bank/account'


export const EP_LOGIN = '/api/login'
export const EP_LOGIN_WITH_HASH = '/ip/address/update/via/email'
export const EP_USER_LOGIN_2FA = '/api/login/twofa'
export const EP_LOGOUT = '/signout'
export const EP_FRESH_DATA = '/get/fresh/user/data'
export const EP_FORGOT_PASSWORD = '/forgot/password'
export const EP_RESET_PASSWORD_FROM_HASH = '/change/via/forgot/password'
export const EP_CHANGE_PASSWORD = '/change/password'
//============================================common-plugin==============================================
export const EP_GET_PROFILE_INFO = '/get/user/profile'
export const EP_GENERATE_2FA_QRCODE = '/generate/twofa/qrcode'
export const EP_VERIFY_2FA_QRCODE = '/verify/twofa/secret'
export const EP_DISABLE_2FA_QRCODE = '/disable/twofa'
//=============================================registerStep plugin=======================================
export const EP_STEP1 = '/api/create/lead'
export const EP_STEP2 = '/api/verify/otp/lead'
export const EP_STEP3 = '/api/user/register'
export const EP_GET_STEP_INFO = '/get/registration/data'
export const EP_DEL_DOC = '/delete/register/docs'

export const EP_STEP4 = '/add/individual/personal/information'
export const EP_STEP5 = '/terms/agreed'
export const EP_STEP6 = '/add/individual/docs'
export const EP_GENERATE_OTP = '/individual/ipv/otp'

export const EP_COR_STEP4 = '/add/corporate/org/information'
export const EP_COR_STEP5 = '/add/corporate/personal/information'
export const EP_COR_STEP7 = '/add/corporate/docs'
//=============================================support plugin=============================================
export const EP_TICKET_REQUEST_OTP = '/ticket/request/otp'
export const EP_TICKET_CHECK_OTP = '/ticket/request'
export const EP_GET_TICKET_LIST = '/list/ticket'
export const EP_GET_TICKET_DETAIL = '/ticket/details'
export const EP_TICKET_REPLY = '/create/ticket/thread'
export const EP_GET_TICKET_REASON_LIST = '/get/ticket/reasons'
export const EP_TICKET_RESEND_OTP = '/ticket/request/otp/resend'
//========================================deposit-withdrawal pluigin====================================================
export const EP_GENERATE_WALLET_ADDRESS = '/deposit/request/operations'


export const EP_GET_USER_CAN_DEPOSIT = '/get/deposit/methods'
export const EP_TRANS_LIMIT_CURRENCY = '/get/deposit/limit'
export const EP_DEMO_DEPOSIT = '/deposit/demo/account'
export const EP_CREDIT_CARD_DEPOSIT = '/get/deposit/url'


export const EP_WITHDRAWAL_REQUEST_OTP = '/withdrawal/request/otp'
export const EP_WITHDRAWAL_CHECK_OTP = '/withdrawal/request'
export const EP_RESEND_EMAIL_LINK = '/withdrawal/request/resend/otp'
export const EP_GET_WITHDRAWAL_DESC = '/get/withdrawal/desc'

export const EP_GET_WITHDRAWAL_METHODS = '/get/withdrawal/methods'

// ========================order list======================
export const EP_OPEN_ORDER_LIST = '/get/open/orders'
export const EP_CANCEL_ORDER_LIST = '/get/cancel/orders'
export const EP_COMPLETED_ORDER_LIST = '/get/filled/orders'
export const EP_ORDER_LIST = '/get/orders'
// =====================trading account======================
export const EP_TRADING_ACCOUNT = '/get/trading/account/list'
// =======================Crypto list========================
export const EP_CRYPTO_LIST = '/get/crypto/list'
// =======================Crypto list========================
export const EP_GET_MARGIN_INFO = '/get/margin/info'
// =======================payment Method=====================
export const EP_GET_PAYMENT_METHODS = '/get/payment/methods'
// =======================IP ADDRESS=========================
export const EP_IP_ADDRESS_LIST = '/ip/address/list'
export const EP_ADD_IP_ADDRES = '/add/ip/address'
export const EP_UPDATE_IP_ADDRES = '/ip/address/update'
// ================== transaction History ===============
export const EP_DEPOSIT_HISTORY = ''
export const EP_WITHDRAWAL_HISTORY = ''
// ================== Login Info =========================
export const EP_LOGIN_INFO = ''
// ============== favorite Currency List ================
export const EP_GET_FAVORITE_CURRENCY_LIST = '/get/favorite/currency'
export const EP_ADD_FAVORITE_CURRENCY_LIST = '/add/favorite/currency'

export const EP_GET_DEPOSIT_LIST = '/get/deposit/list'
export const EP_GET_WITHDRAWAL_LIST = '/get/withdrawal/list'
export const EP_GET_IMAGE_OTP = '/individual/ipv/otp'
export const EP_GET_NOTIFICATION_LIST = '/common/get/notification'
export const EP_READ_UNREAD_NOTIFICATION = '/common/update/unread/notification/as/read'
export const EP_NOTIFICATION_SETTINGS = '/user/notification/settings'
export const EP_NOTIFICATION_GET_SETTINGS = '/get/user/notification/settings'
export const EP_NOTIFICATION_ENABLE_GET_SETTINGS = '/get/enable/notifications'


export const EP_GET_API_KEYS = '/get/api/keys'
export const EP_UPDATE_API_KEYS = '/update/api/key'
export const EP_DISABLE_API_KEYS = '/disable/api/key'
export const EP_UPDATE_API_WEBOOK = '/update/api/webhook'
export const EP_GET_WALLET_MARGIN = '/get/transaction/wallet/margin'
export const EP_CONFIRM_WALLET_TRANSACTION = '/complete/wallet/transaction'

//Steps for social trading
export const EP_CREATE_ACCOUNT = '/create/account'
export const EP_INTERNAL_TRANSFER_VERIFY = '/internal/transfer'
export const EP_GENERATE_API_KEY = '/create/api/key'

/** Crypo Addresses */
export const EP_GET_CRYPTO_ADDRESSES = '/deposit/addresses'

/** Bank addresses list */
export const EP_GET_BANK_ADDRESSES = '/get/bank/accounts'

/** Portfolio Reports  */
export const EP_PORTFOLIO_REPORT = '/api/portfolio'

/** Revenue Reports  */
export const EP_REVENUE_REPORT = '/deposit/volume'

export const EP_GET_WATCH_LIST = '/api/user/watchlist/get'

export const EP_GET_NEWS_LIST = '/get/news'

/** Deposit / Withdrawal Currency  */
export const EP_GET_WITH_DEPO_CUR_LIST = '/currencies'

/** Questionare  */
export const EP_GET_QUESTION = '/get/questionnaire'
export const EP_QUESTION = '/add/questionnaire'
export const EP_FINANCIAL_QUESTION = '/add/financial/info'

export const EP_FINANCIAL_DOCS = '/add/financial/docs'



// WEBPACK FOOTER //
// ./src/store/api/endpoints.js